import { formatAmount } from 'vopay';

/**
 * The currency's own symbol ("$", "€", "£"), or nothing when it has none of its own (CHF renders as
 * its code, which the caller already shows).
 */
function currencySymbol(currency: string) {
  const symbol = new Intl.NumberFormat('en-US', { style: 'currency', currency, currencyDisplay: 'narrowSymbol' })
    .formatToParts(0)
    .find((part) => part.type === 'currency')?.value;

  return symbol && symbol !== currency ? symbol : '';
}

/**
 * An amount in the chart's "CAD $88,450.00" shape: the figure as every other balance in the portal
 * formats it (`formatAmount`), the currency's symbol in front, and the code before that so two
 * currencies never read alike. `withCode: false` leaves the code to the caller (a card label that
 * already names it). Without a currency the plain figure stands.
 */
export default function formatOrganizationBalance(
  amount: string,
  currency: string | null,
  { withCode = true }: { withCode?: boolean } = {},
) {
  if (!currency) return formatAmount(amount);

  const figure = `${currencySymbol(currency)}${formatAmount(amount)}`;

  return withCode ? `${currency} ${figure}` : figure;
}
